
export function calculateGridSize(questions) {
  let maxRow = 0;
  let maxColumn = 0;

  questions.forEach(question => {
    question.lettersPositions.forEach(({ id }) => {
      const [row, column] = id.split('-').map(Number);
      maxRow = Math.max(maxRow, row + 1);
      maxColumn = Math.max(maxColumn, column + 1);
    });
  });

  return { rows: maxRow, columns: maxColumn };
}

export function getLetterPositions(distribution, word) {
  const positions = [];
  let { row, column, direction } = distribution;

  for (let i = 0; i < word.length; i++) {
    positions.push({ id: `${row}-${column}`, value: word[i] });

    if (direction === 'N') row--;
    else if (direction === 'S') row++;
    else if (direction === 'E') column++;
    else if (direction === 'O') column--;
  }

  return positions;
}

export function calculateIndexPositions(questions) {
  return questions.reduce((acc, question) => {
    const firstLetter = question.lettersPositions[0];
    acc[firstLetter.id] = question.number;
    return acc;
  }, {})
}

export function initializeLetterState(questions) {
  return questions.flatMap(question =>
    question.lettersPositions.map(letter =>
      ({ [letter.id]: { value: "", correct: null } })
    )
  ).reduce((acc, obj) => Object.assign(acc, obj), {})
}